// import getIntervalParams from "../../common/Helper/getIntervalParams";
// import axios from "axios";

// export const fetchFilteredTableData = async (
//   pageSize,
//   currentPage,
//   activeTab,
//   startDate,
//   endDate,
//   searchFields
// ) => {
//   const params = getIntervalParams(activeTab, startDate, endDate);
//   params.limit = pageSize;

//   const SearchParams = new URLSearchParams(params).toString();
//   const url = `${process.env.REACT_APP_GET_OPERATION_HOME_API}&${SearchParams}`;

//   const response = await axios.post(url, {
//     client: searchFields.client || "",
//     search: searchFields.search || "",
//     callStatus: searchFields.callStatus || "",
//     searchText: searchFields.searchText || "",
//     severity: searchFields.severity || "",
//     sort: searchFields.sort || "",
//     sortType: searchFields.sortType || "",
//     page: currentPage,
//   });

//   return response.data;
// };

// import { logDOM } from "@testing-library/react";
// import getIntervalParams from "../../common/Helper/getIntervalParams";
// import axios from "axios";
// import CryptoJS from "crypto-js";

// // Secret key for encryption (must match backend key)
// const SECRET_KEY = "1234567890abcdef1234567890abcdef"; // Ensure this is securely managed
// // console.log("Secret Key Length:", SECRET_KEY.length);

// // Encrypt function using CryptoJS
// const encryptPayload = (data) => {
//   const ciphertext = CryptoJS.AES.encrypt(
//     JSON.stringify(data),
//     SECRET_KEY
//   ).toString();
//   return ciphertext;
// };

// export const fetchFilteredTableData = async (
//   pageSize,
//   currentPage,
//   activeTab,
//   startDate,
//   endDate,
//   searchFields
// ) => {
//   const params = getIntervalParams(activeTab, startDate, endDate);
//   params.limit = pageSize;

//   const SearchParams = new URLSearchParams(params).toString();
//   const url = `${process.env.REACT_APP_GET_OPERATION_HOME_API}&${SearchParams}`;

//   // Original payload
//   const payload = {
//     client: searchFields.client || "",
//     search: searchFields.search || "",
//     callStatus: searchFields.callStatus || "",
//     searchText: searchFields.searchText || "",
//     severity: searchFields.severity || "",
//     sort: searchFields.sort || "",
//     sortType: searchFields.sortType || "",
//     page: currentPage,
//     type: searchFields.type || "",
//   };
//   function decryptFunction(ciphertext, key) {
//     // Decrypt
//     let bytes = CryptoJS.AES.decrypt(ciphertext, key);
//     let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
//     return decryptedData;
//   }
//   // Encrypt the payload
//   const encryptedPayload = encryptPayload(payload);

//   // Send the encrypted payload to the backend
//   const response = await axios.post(url, { encryptedData: encryptedPayload }  );
//   const decrypteddata = decryptFunction(response.data, SECRET_KEY);
//   // console.log("seret", decrypteddata);

//   return decrypteddata;
// };
import { logDOM } from "@testing-library/react";
import getIntervalParams from "../../common/Helper/getIntervalParams";
import axios from "axios";
import CryptoJS from "crypto-js";

// Secret key for encryption (must match backend key)
const SECRET_KEY = "1234567890abcdef1234567890abcdef";

// Encrypt function using CryptoJS
const encryptPayload = (data) => {
  const ciphertext = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    SECRET_KEY
  ).toString();
  return ciphertext;
};

export const fetchFilteredTableData = async (
  pageSize,
  currentPage,
  activeTab,
  startDate,
  endDate,
  searchFields
) => {
  const authToken = localStorage.getItem("authToken");

  const params = getIntervalParams(activeTab, startDate, endDate);
  params.limit = pageSize;

  const SearchParams = new URLSearchParams(params).toString();
  const url = `${process.env.REACT_APP_GET_OPERATION_HOME_API}&${SearchParams}`;

  // Original payload
  const payload = {
    client: searchFields.client || "",
    search: searchFields.search || "",
    callStatus: searchFields.callStatus || "",
    searchText: searchFields.searchText || "",
    severity: searchFields.severity || "",
    sort: searchFields.sort || "",
    sortType: searchFields.sortType || "",
    page: currentPage,
    type: searchFields.type || "",
  };


  function decryptFunction(ciphertext, key) {
    let bytes = CryptoJS.AES.decrypt(ciphertext, key);
    let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decryptedData;
  }
  console.log("[fetchFilteredTableData] ---- REQUEST ----");
  console.log("[fetchFilteredTableData] activeTab:", activeTab);
  console.log("[fetchFilteredTableData] startDate:", startDate, "| endDate:", endDate);
  console.log("[fetchFilteredTableData] pageSize:", pageSize, "| currentPage:", currentPage);
  console.log("[fetchFilteredTableData] searchFields:", searchFields);
  console.log("[fetchFilteredTableData] payload (POST body):", payload);
  console.log("[fetchFilteredTableData] URL params:", SearchParams);
  console.log("[fetchFilteredTableData] Full URL:", url);

  // Encrypt the payload
  const encryptedPayload = encryptPayload(payload);

  // Send the encrypted payload to the backend (with auth)
  const response = await axios.post(
    url,
    { encryptedData: encryptedPayload },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    }
  );

  const decrypteddata = decryptFunction(response.data, SECRET_KEY);

  console.log("[fetchFilteredTableData] ---- RESPONSE ----");
  console.log("[fetchFilteredTableData] HTTP status:", response.status);
  console.log("[fetchFilteredTableData] datafound:", decrypteddata?.datafound);
  console.log("[fetchFilteredTableData] total_rows:", decrypteddata?.total_rows);
  console.log("[fetchFilteredTableData] data length:", decrypteddata?.data?.length);
  console.log("[fetchFilteredTableData] full response:", decrypteddata);

  return decrypteddata;
};
